import {ChangeDetectionStrategy, Component, input, InputSignal, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';

import {DrawingModel, EventRankingModel, GameModel, GroupRankingModel, TournamentModel} from 'shared/models';
import {TournamentsCategoriesUi} from '../tournaments-categories-ui/tournaments-categories-ui';

@Component({
  selector: 'view-ui',
  standalone: true,
  imports: [CommonModule, MatCard, MatCardContent, MatCardHeader, MatCardTitle, TournamentsCategoriesUi],
  templateUrl: './view-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewUi implements OnInit {
  tournament: InputSignal<TournamentModel> = input.required<TournamentModel>();
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();
  groupsRankings: InputSignal<GroupRankingModel[]> = input.required<GroupRankingModel[]>();
  eventsRankings: InputSignal<EventRankingModel[]> = input.required<EventRankingModel[]>();

  // protected drawings = computed((): DrawingModel[] => {
  //   return this.drawingsState()?.list || [];
  // });

  // protected games = computed((): GameModel[] => {
  //   // @TODO: descomentar
  //   // return this.gamesState()?.list || [];
  //   return [];
  // });

  // protected groupsRankings = computed((): GroupRankingModel[] => {
  //   // @TODO: descomentar
  //   // return this.groupsRankingsState()?.list || [];
  //   return [];
  // });

  protected activeTab!: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    // public themeService: CustomizerSettingsService
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['tab']) {
      this.activeTab = this.route.snapshot.queryParams['tab'];
    } else {
      this.activeTab = 0;
    }
  }

  changeTab(tab: number): void {
    // Cambia el contenido del tab
    this.activeTab = tab;

    // Actualiza los parametros de la url
    const extras: NavigationExtras = {
      relativeTo: this.route,
      queryParams: {tab: this.activeTab},
    };
    this.router.navigate(['.'], extras);
  }
}
